import { amt } from "../lib/invoice";

export const ErpReconciliation = ({ report }) => {
  if (!report) return null;
  const labels = { new: "Yeni", changed: "Güncelleme", removed: "Pasifleştirme" };
  return <div data-testid="erp-reconciliation-result">
    <p className="notice" role="status" data-testid="erp-reconciliation-summary">
      {report.months.length} dönem · {report.source_sale_count} satış · {report.counts.new} yeni · {report.counts.changed} değişen · {report.counts.removed} pasifleştirilecek
    </p>
    {!report.changes.length ? <p data-testid="erp-reconciliation-matched">Tüm dönemler kaynak satışlarla eşleşiyor.</p> :
      <div className="table-wrap"><table data-testid="erp-reconciliation-table">
        <thead><tr><th>Tarih / hesap</th><th>Durum</th><th>Ciro: önce → kaynak</th><th>Satış: önce → kaynak</th></tr></thead>
        <tbody>{report.changes.map(row => <tr key={row.erp_key} data-testid={`erp-reconcile-row-${row.erp_key}`}>
          <td>{row.transaction_date}<small className="sub-line">{row.account} · {row.group}</small></td>
          <td>{labels[row.status]}</td>
          <td data-testid={`erp-reconcile-gross-${row.erp_key}`}>{amt(row.previous_gross_revenue || 0, row.currency)} → {amt(row.gross_revenue, row.currency)}</td>
          <td data-testid={`erp-reconcile-sales-${row.erp_key}`}>{row.previous_sale_count || 0} → {row.sale_count}</td>
        </tr>)}</tbody>
      </table></div>}
  </div>;
};